import { el } from './dom';
import { showSettingsModal } from './SettingsModal';

export interface TitleScreenOptions {
  isWeb: boolean;
  canResume: boolean;
  onNewGame(): void;
  onResume(): void;
  onTutorial(): void;
}

const ITCH_URL = 'https://kentsgames.itch.io';
const KENTS_GAMES_URL = 'https://kentsgames.com';

/** Full-screen main menu over the paused live game world (the desert itself
 * is the title art). Web and desktop builds get different button sets. */
export function showTitleScreen(root: HTMLElement, opts: TitleScreenOptions): void {
  const dismiss = (): void => backdrop.remove();

  const menu = el('div', { class: 'title-menu' });
  const button = (label: string, onclick: () => void, extra = ''): HTMLButtonElement => {
    const node = el('button', { class: `title-button${extra ? ` ${extra}` : ''}`, onclick }, label);
    menu.append(node);
    return node;
  };
  const link = (label: string, href: string): void => {
    menu.append(el('a', { class: 'title-button link', href, target: '_blank', rel: 'noopener' }, label));
  };

  button('Tutorial', () => opts.onTutorial());
  button('New Game', () => {
    if (!opts.isWeb && opts.canResume) {
      confirmAbandon();
      return;
    }
    dismiss();
    opts.onNewGame();
  }, 'primary');
  if (opts.isWeb) {
    link('Download for free on Itch.io!', ITCH_URL);
  } else {
    const resume = button('Resume Game', () => {
      dismiss();
      opts.onResume();
    });
    resume.disabled = !opts.canResume;
  }
  button('Settings', () => showSettingsModal(root));
  link("View more of Kent's Games", KENTS_GAMES_URL);

  const panel = el(
    'div',
    { class: 'title-panel' },
    el('div', { class: 'title-wordmark' }, 'BOOMTOWN'),
    el('div', { class: 'title-tagline' }, "Dig. Sell. Build a town the desert can't kill."),
    menu,
    el(
      'div',
      { class: 'title-footnote' },
      opts.isWeb ? 'Playing in the browser — progress is not saved. Download the game to keep your town.' : 'A Kent game.',
    ),
  );

  const backdrop = el('div', { class: 'title-backdrop' }, panel);
  root.append(backdrop);

  /** Desktop New Game with an existing save: warn before the bulldozer. */
  function confirmAbandon(): void {
    const confirmBackdrop = el(
      'div',
      { class: 'modal-backdrop' },
      el(
        'div',
        { class: 'panel modal' },
        el('div', { class: 'modal-title' }, 'Abandon this site?'),
        el('div', { class: 'payrow' }, 'Your current town will be deleted and a fresh claim surveyed.'),
        el(
          'button',
          {
            class: 'modal-close',
            onclick: () => {
              confirmBackdrop.remove();
              dismiss();
              opts.onNewGame();
            },
          },
          'Abandon and start fresh',
        ),
        el('button', { class: 'modal-close secondary', onclick: () => confirmBackdrop.remove() }, 'Never mind'),
      ),
    );
    root.append(confirmBackdrop);
  }
}
